import { AnimType } from '@tencent/slide-sdk-model';
import {  FLOAT_IN, FLOAT_OUT } from './constants';
import { ANIMATION_ICON_LIST } from '../constants';
import { PATH_ANIM_TYPES } from '@src/slide/domain/ui-model/element-modeles/property/animation/constant';
import { colorAnimTypeList } from '@src/js/js-keyframe-animation/style-converter/constants';

/**
 * 获取动画图标
 * @param animType AnimType
 * @returns
 */
export const  getAnimIcon = (animType: AnimType) => {
    const animIconMap = {
        [FLOAT_IN]: AnimType.FloatUpOut,
        [FLOAT_OUT]: AnimType.FloatUpIn,
        [AnimType.FloatDownOut]: AnimType.FloatUpOut,
        [AnimType.FloatDownIn]: AnimType.FloatUpIn,
        [AnimType.EntrShapeBox]: AnimType.EntrShapeCircle,
        [AnimType.EntrShapeDiamond]: AnimType.EntrShapeCircle,
        [AnimType.EntrShapePlus]: AnimType.EntrShapeCircle,
        [AnimType.ExitShapeBox]: AnimType.ExitShapeCircle,
        [AnimType.ExitShapeDiamond]: AnimType.ExitShapeCircle,
        [AnimType.ExitShapePlus]: AnimType.ExitShapeCircle,
    };
    const animIndex = ANIMATION_ICON_LIST.findIndex(item => item.id === animType || animIconMap[animType] === item.id);
    return animIndex > -1 ? ANIMATION_ICON_LIST[animIndex].icon : null;
};

/**
 * 判断是否是路径动画
 * @param animType AnimType
 * @returns boolean
 */
export const isPathAnim = (animType: AnimType): boolean => Object.values(PATH_ANIM_TYPES).includes(animType);

/**
 * 判断是否是颜色动画
 * @param animType AnimType
 * @returns boolean
 */
export const isColorAnim = (animType: AnimType): boolean => colorAnimTypeList.includes(animType);
